export let ResourceType = /*#__PURE__*/function (ResourceType) {
  ResourceType["ARTICLES"] = "RESOURCE_ARTICLES";
  return ResourceType;
}({});
//# sourceMappingURL=KnowledgeBase.js.map